<template>
  <v-dialog v-model="dialogShowBill" full-width>
    <v-card>
      <v-card-title>
        COMPETÊNCIA: {{ invoice.competence | formatCompetence }}
      </v-card-title>
      <v-card-text style="text-align: center">
        <div>
          <object
            :data="invoice.bill_url"
            type="application/pdf"
            width="100%"
            height="570"
          >
            alt : <a :href="invoice.bill_url">{{ invoice.bill_url }}</a>
          </object>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialogShowBill = false"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";

export default {
  data() {
    return {
      dialogShowBill: false,
      invoice: {},
    };
  },
  created() {
    eventBus.$on("showBill", (invoice) => {
      this.invoice = invoice;
      if (invoice) this.dialogShowBill = true;
    });
  },
  filters: {
    formatCompetence(value) {
      const year = String(value).split("-")[0];
      const mounth = String(value).split("-")[1];
      return mounth + "/" + year;
    },
  },
};
</script>
<style scoped></style>
